"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldOutputPrettyJson = void 0;
const shouldOutputPrettyJson = () => process.env.AWS_EXECUTION_ENV !== "AWS_ECS_FARGATE" && process.env.DAYTRIP_FORCE_COMPACT_JSON !== "true";
exports.shouldOutputPrettyJson = shouldOutputPrettyJson;
//# sourceMappingURL=should-output-pretty-json.js.map